(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jebla-coffee-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jebla-coffee-finder')) {
    customElements.define('jebla-coffee-finder', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.form = this.querySelector('form');
        this.results = this.querySelector('.jcf__results');
        this.grid = this.querySelector('.jcf__grid');
        this.messages = Object.fromEntries([...this.querySelectorAll('[data-message]')].map(el => [el.dataset.message, el.textContent]));
        this.cards = [...this.querySelector('template').content.querySelectorAll('article')].map(el => ({el, acidity:Number(el.dataset.acidity),bitterness:Number(el.dataset.bitterness),body:Number(el.dataset.body),flavors:JSON.parse(el.dataset.flavors),brewing:JSON.parse(el.dataset.brewing)})).filter(p => ['acidity','bitterness','body'].every(k => Number.isInteger(p[k]) && p[k]>=1 && p[k]<=10) && Array.isArray(p.flavors) && p.flavors.length && Array.isArray(p.brewing) && p.brewing.length);
        this.form.hidden = false;
        this.flavorInputs = [...this.form.querySelectorAll('input[name=flavor]')];
        this.form.addEventListener('input', () => {this.results.hidden=true;this.updateFlavorLimit();});
        this.updateFlavorLimit();
        this.form.addEventListener('reset', () => {requestAnimationFrame(() => {this.results.hidden=true;this.grid.replaceChildren();this.updateFlavorLimit();});});
        this.form.addEventListener('submit', e => {e.preventDefault();this.recommend();});
        
      }
      updateFlavorLimit() {
        const selected=this.flavorInputs.filter(input=>input.checked);
        selected.slice(3).forEach(input=>{input.checked=false;});
        const count=Math.min(selected.length,3);
        this.flavorInputs.forEach(input=>{input.disabled=count===3&&!input.checked;});
        this.querySelector('.jcf__selection-status').textContent=this.messages.selection_count.replace('[count]',new Intl.NumberFormat(this.dataset.locale).format(count))+(count===3?' '+this.messages.selection_limit:'');
      }
      matchProfile(p, data, flavors) {
        const metrics=['acidity','bitterness','body'].filter(k=>['low','medium','high'].includes(data.get(k)));
        const matches=flavors.filter(f=>p.flavors.includes(f));
        const notesWeight=flavors.length?0.6:0;
        const metricsWeight=metrics.length?0.4:0;
        const totalWeight=notesWeight+metricsWeight;
        const notesMatch=flavors.length?matches.length/flavors.length:0;
        const metricsMatch=metrics.length?metrics.reduce((sum,k)=>sum+1-this.distance(p[k],data.get(k))/(data.get(k)==='medium'?4:7),0)/metrics.length:0;
        const compatibility=totalWeight?(notesWeight*notesMatch+metricsWeight*metricsMatch)/totalWeight:0;
        const exact=totalWeight>0&&matches.length===flavors.length&&metrics.every(k=>this.distance(p[k],data.get(k))===0);
        const match=totalWeight?Math.min(exact?100:99,Math.max(0,Math.round(100*compatibility))):null;
        const score=1-compatibility;
        return {...p,matches,score,exact,match};
      }
      level(value) { return value <= 3 ? 'low' : value <= 6 ? 'medium' : 'high'; }
      distance(value, level) {
        const [min,max]={low:[1,3],medium:[4,6],high:[7,10]}[level];
        return Math.max(min-value,0,value-max);
      }
      recommend() {
        const data=new FormData(this.form), flavors=data.getAll('flavor');
        const metrics=['acidity','bitterness','body'].filter(k=>data.get(k)!=='any');
        const preferences=metrics.length>0||flavors.length>0;
        const ranked=this.cards.map(p=>this.matchProfile(p,data,flavors)).sort((a,b)=>(b.match??0)-(a.match??0)||a.score-b.score);
        this.querySelector('.jcf__match-help').hidden=!preferences;
        this.grid.replaceChildren();
        this.querySelector('.jcf__status').textContent=!ranked.length?this.messages.empty:!preferences?this.messages.explore:!ranked[0].exact?this.messages.fallback:'';
        ranked.forEach((p,i)=>{
          const card=p.el.cloneNode(true);
          card.querySelector('.jcf__badge').textContent=preferences&&i===0?this.messages.best:this.messages.alternative;
          card.querySelector('.jcf__reason').textContent=this.messages.acidity_label+': '+this.messages['acidity_'+this.level(p.acidity)];
          card.querySelector('.jcf__metrics').textContent=['bitterness','body'].map(k=>this.messages[k]+': '+this.messages[k+'_'+this.level(p[k])]).join(' · ');
          card.querySelector('.jcf__flavor-reason').textContent=flavors.length?(p.matches.length?this.messages.matching_notes+' '+p.matches.map(f=>this.messages[f]).join('، '):this.messages.different_notes):p.flavors.map(f=>this.messages[f]||f).join('، ');
          if(p.match!==null){
            card.querySelector('.jcf__match').hidden=false;
            card.querySelector('.jcf__match-value').textContent=new Intl.NumberFormat(this.dataset.locale,{style:'percent',maximumFractionDigits:0}).format(p.match/100);
            card.querySelector('.jcf__match-track span').style.width=p.match+'%';
          }
          const add=card.querySelector('.jcf__add');
          add.addEventListener('click',async()=>{
            const label=add.textContent;add.disabled=true;add.textContent=this.messages.adding;
            const status=card.querySelector('.jcf__cart-status');status.textContent='';
            try {
              const response=await fetch(this.dataset.cartAdd,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:card.dataset.id,quantity:1}]})});
              if(!response.ok)throw new Error('cart');
              await response.json();
              status.textContent=this.messages.added;
              card.querySelector('.jcf__cart-link').hidden=false;
            }catch(e){status.textContent=this.messages.error;}
            finally{add.disabled=false;add.textContent=label;}
          });
          this.grid.append(card);
        });
        this.results.hidden=false;
        this.results.querySelector('h3').focus({preventScroll:true});
        this.results.scrollIntoView({behavior:'auto',block:'start'});
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
